import regionApi from '~/clientApis/regionApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { getStore } from '~/mobx/AppStore';

const getRegionById = async () => {
    const { generalSettingsStore, regionStore } = getStore();
    const { selectedRegionId } = regionStore;

    if (!selectedRegionId) {
        return;
    }

    generalSettingsStore.setIsLoadingRegionData(true);

    try {
        const region = await regionApi.getRegionById(selectedRegionId);
        generalSettingsStore.setSelectedRegionData(region);
    } catch (error) {
        showMessageModal('error', 'Error fetching region data');
        throw error;
    } finally {
        generalSettingsStore.setIsLoadingRegionData(false);
    }
};

export default getRegionById;
